// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ref: parceiros_formulario.html - estrutura e cores idênticas */
.stylesForm_root__hN1xE {
  font-family: 'Roboto', sans-serif;
  color: #3c4043;
  min-height: 100vh;
  padding: 24px 0;
}

.stylesForm_formContainer__wuR\\+l {
  margin: 0 2rem;
  box-sizing: border-box;
  background: #f5f5f5;
  padding: 24px;
  border-radius: 12px;
}

@media (max-width: 780px) {
  .stylesForm_formContainer__wuR\\+l {
    margin: 0 1rem;
    padding: 16px;
  }
}

.stylesForm_breadcrumb__cLiic {
  padding: 12px 24px;
  font-size: 13px;
  color: #80868b;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #ffffff;
  border-bottom: 1px solid #e8eaed;
  border-radius: 12px;
  margin-bottom: 24px;
}

.stylesForm_breadcrumbLink__xkKLq {
  color: #1a73e8;
  text-decoration: none;
}

.stylesForm_breadcrumbLink__xkKLq:hover {
  text-decoration: underline;
}

.stylesForm_breadcrumbSep__Rnq87 {
  color: #bdc1c6;
}

.stylesForm_mainContent__gR9QC {
  padding: 2px 0 8px;
  max-width: none;
  box-sizing: border-box;
}

.stylesForm_pageTitleSection__30LHC {
  margin-bottom: 24px;
}

.stylesForm_pageTitle__dHu3d {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #1b3a5f;
  font-size: 26px;
  font-weight: 600;
  letter-spacing: -0.3px;
  margin: 0;
}

.stylesForm_pageTitleIcon__8QoEl {
  font-size: 32px;
}

.stylesForm_card__TwQkj {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.06);
  overflow: hidden;
  margin-bottom: 24px;
}

.stylesForm_cardHeader__QuRNi {
  padding: 16px 20px;
  border-bottom: 1px solid #e8eaed;
  font-size: 15px;
  font-weight: 500;
  color: #3c4043;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f8f9fa;
}

.stylesForm_cardHeaderIcon__ztzfM {
  font-size: 22px;
  color: #1b3a5f;
}

.stylesForm_cardBody__zBzK6 {
  padding: 20px;
}

.stylesForm_formGrid__FOLUV {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.stylesForm_formGroup__obWi\\+ {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.stylesForm_formGroupSpan2__tIs0o {
  grid-column: span 2;
}

.stylesForm_formGroupSpan3__eyMG4 {
  grid-column: span 3;
}

.stylesForm_formGroupSpan4__S6pg4 {
  grid-column: span 4;
}

.stylesForm_formGroup__obWi\\+ label {
  font-size: 12px;
  font-weight: 500;
  color: #5f6368;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stylesForm_formGroup__obWi\\+ label.stylesForm_required__ZPTd6::after {
  content: ' *';
  color: #ea4335;
}

.stylesForm_formGroup__obWi\\+ .MuiAutocomplete-input::selection {
  background-color: transparent;
  color: inherit;
}

.stylesForm_formGroup__obWi\\+ input:not([class*="Mui"]),
.stylesForm_formGroup__obWi\\+ select,
.stylesForm_formGroup__obWi\\+ textarea {
  padding: 10px 12px;
  border: 1px solid #dadce0;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  color: #3c4043;
  background: #ffffff;
}

.stylesForm_formGroup__obWi\\+ input:not([class*="Mui"]):focus,
.stylesForm_formGroup__obWi\\+ select:focus,
.stylesForm_formGroup__obWi\\+ textarea:focus {
  outline: none;
  border-color: #1a73e8;
  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);
}

.stylesForm_formGroup__obWi\\+ input[readonly] {
  background: #f8f9fa;
}

.stylesForm_formGroup__obWi\\+ textarea {
  resize: vertical;
  min-height: 80px;
}

.stylesForm_formHelper__sk2Ce {
  font-size: 12px;
  color: #9aa0a6;
  margin-top: 4px;
}

.stylesForm_sectionTitle__0-8Yz {
  font-size: 13px;
  font-weight: 600;
  color: #1b3a5f;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 16px;
  margin-top: 24px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.stylesForm_sectionTitleFirst__h5Rwt {
  margin-top: 0;
}

.stylesForm_sectionTitleIcon__1Xx-7 {
  font-size: 18px;
}

.stylesForm_infoBox__U8\\+Ug {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  background: #e8f0fe;
  border-radius: 6px;
  border-left: 4px solid #1a73e8;
  margin-bottom: 16px;
}

.stylesForm_infoBoxIcon__Z7eyf {
  color: #1a73e8;
  font-size: 20px;
  margin-top: 2px;
}

.stylesForm_infoBoxTitle__uu6tL {
  font-weight: 500;
  color: #202124;
  margin-bottom: 4px;
  font-size: 13px;
}

.stylesForm_infoBoxText__kIJd\\+ {
  font-size: 12px;
  color: #5f6368;
  line-height: 1.5;
}

.stylesForm_toggleContainer__cKW2j {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-top: 22px;
}

.stylesForm_toggleSwitch__bAm6z {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 24px;
}

.stylesForm_toggleSwitch__bAm6z input {
  opacity: 0;
  width: 0;
  height: 0;
}

.stylesForm_toggleSlider__U2GNv {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #bdc1c6;
  transition: 0.3s;
  border-radius: 24px;
}

.stylesForm_toggleSlider__U2GNv::before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.stylesForm_toggleSwitch__bAm6z input:checked + .stylesForm_toggleSlider__U2GNv {
  background-color: #34a853;
}

.stylesForm_toggleSwitch__bAm6z input:checked + .stylesForm_toggleSlider__U2GNv::before {
  transform: translateX(24px);
}

.stylesForm_toggleLabel__8n-jF {
  font-size: 14px;
  color: #5f6368;
  font-weight: 500;
}

.stylesForm_documentTypeContainer__\\+NbjV {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e8eaed;
}

.stylesForm_documentTypeLabel__SJheI {
  font-size: 14px;
  font-weight: 500;
  color: #5f6368;
}

.stylesForm_documentTypeLabelActive__PP4UY {
  color: #1a73e8;
}

.stylesForm_fileUploadArea__KqT9H {
  border: 2px dashed #dadce0;
  border-radius: 6px;
  padding: 20px;
  text-align: center;
  background: #f8f9fa;
  cursor: pointer;
  transition: all 0.2s;
}

.stylesForm_fileUploadArea__KqT9H:hover {
  border-color: #1a73e8;
  background: #e8f0fe;
}

.stylesForm_fileUploadIcon__Rgh2q {
  font-size: 48px;
  color: #bdc1c6;
  margin-bottom: 8px;
  display: block;
}

.stylesForm_fileUploadText__ZOmKQ {
  font-size: 14px;
  color: #5f6368;
  margin-bottom: 4px;
}

.stylesForm_fileUploadHint__Qt6Mm {
  font-size: 12px;
  color: #9aa0a6;
}

.stylesForm_tableWrapper__wgl2u {
  overflow-x: auto;
}

.stylesForm_sociosTable__TWxaN {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e8eaed;
  border-radius: 6px;
  overflow: hidden;
}

.stylesForm_sociosTable__TWxaN thead {
  background: #1b3a5f;
}

.stylesForm_sociosTable__TWxaN th {
  padding: 12px;
  text-align: left;
  font-size: 13px;
  font-weight: 500;
  color: #ffffff;
}

.stylesForm_sociosTable__TWxaN td {
  padding: 12px;
  border-top: 1px solid #e8eaed;
}

.stylesForm_sociosTable__TWxaN tbody tr:hover {
  background: #f8f9fa;
}

.stylesForm_sociosTable__TWxaN input {
  width: 100%;
  padding: 8px;
  border: 1px solid #dadce0;
  border-radius: 4px;
  font-size: 13px;
}

.stylesForm_sociosTable__TWxaN input:focus {
  outline: none;
  border-color: #1a73e8;
}

.stylesForm_btnAddRow__15rHq {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  padding: 8px 16px;
  background: #34a853;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
}

.stylesForm_btnAddRow__15rHq:hover {
  background: #2d9249;
}

.stylesForm_btnRemoveRow__nrSny {
  background: #fce8e6;
  color: #ea4335;
  border: none;
  border-radius: 4px;
  padding: 6px 10px;
  font-size: 12px;
  cursor: pointer;
}

.stylesForm_btnRemoveRow__nrSny:hover {
  background: #ea4335;
  color: #ffffff;
}

.stylesForm_actionFooter__R29LH {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  position: sticky;
  bottom: 0;
  z-index: 50;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.06);
  border-radius: 12px;
  margin-top: 24px;
}

.stylesForm_footerInfo__MKgUi {
  font-size: 13px;
  color: #80868b;
}

.stylesForm_footerActions__BwzHJ {
  display: flex;
  gap: 12px;
}

.stylesForm_btn__\\+YD8C {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.15s ease;
  border: none;
}

.stylesForm_btnSuccess__bQP5b {
  background: #34a853;
  color: #ffffff;
}

.stylesForm_btnSuccess__bQP5b:hover {
  background: #2d9249;
}

.stylesForm_btnOutline__7nQil {
  background: transparent;
  border: 1px solid #dadce0;
  color: #5f6368;
}

.stylesForm_btnOutline__7nQil:hover {
  background: #f8f9fa;
  border-color: #bdc1c6;
}

.stylesForm_inputWithAction__ZIAfM {
  display: flex;
  align-items: stretch;
}

.stylesForm_inputWithAction__ZIAfM input {
  flex: 1 1;
  border-radius: 4px 0 0 4px;
  border-right: none;
}

.stylesForm_btnCnpj__5LVxW {
  padding: 0 12px;
  background: #1a73e8;
  color: #ffffff;
  border: 1px solid #1a73e8;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 42px;
  transition: background 0.15s;
  flex-shrink: 0;
}

.stylesForm_btnCnpj__5LVxW:hover:not(:disabled) {
  background: #1557b0;
  border-color: #1557b0;
}

.stylesForm_btnCnpj__5LVxW:disabled {
  background: #9aa0a6;
  border-color: #9aa0a6;
  cursor: not-allowed;
}

.stylesForm_spinnerSmall__YOAWc {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255,255,255,0.4);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: stylesForm_spinSmall__wjIGi 0.7s linear infinite;
  display: inline-block;
}

@keyframes stylesForm_spinSmall__wjIGi {
  to { transform: rotate(360deg); }
}

.stylesForm_tooltipIcon__mvPRH {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #1a73e8;
  color: #ffffff;
  font-size: 12px;
  font-weight: bold;
  margin-left: 6px;
  cursor: help;
}

/* Modal sucesso */
.stylesForm_modalOverlay__4Mmkv {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stylesForm_modalContent__cWzF7 {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.3);
  max-width: 520px;
  width: 90%;
}

.stylesForm_modalHeader__R4KmN {
  padding: 20px 24px;
  border-bottom: 1px solid #e8eaed;
  display: flex;
  align-items: center;
  gap: 12px;
}

.stylesForm_modalTitle__nhrBL {
  font-size: 18px;
  font-weight: 500;
  color: #202124;
  flex: 1 1;
  margin: 0;
}

.stylesForm_modalSuccessIcon__OV9OM {
  font-size: 28px;
  color: #34a853;
}

.stylesForm_modalBody__JUr\\+M {
  padding: 24px;
}

.stylesForm_modalMessage__pUZou {
  font-size: 14px;
  color: #5f6368;
  line-height: 1.6;
  margin-bottom: 20px;
}

.stylesForm_modalHighlight__KykKF {
  font-weight: 500;
  color: #1b3a5f;
}

.stylesForm_modalQuestion__AAPj2 {
  font-size: 15px;
  font-weight: 500;
  color: #202124;
  margin-bottom: 16px;
}

.stylesForm_modalOptions__AwKKk {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.stylesForm_modalOptionBtn__1JhL- {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  border: 2px solid #e8eaed;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  background: #ffffff;
  width: 100%;
  text-align: left;
  font-family: inherit;
}

.stylesForm_modalOptionBtn__1JhL-:hover {
  border-color: #1a73e8;
  background: #e8f0fe;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.stylesForm_modalOptionBtnPrimary__pnc8\\+ .stylesForm_modalOptionIcon__NsBOY {
  color: #1a73e8;
}

.stylesForm_modalOptionIcon__NsBOY {
  font-size: 28px;
  margin-right: 16px;
  color: #80868b;
}

.stylesForm_modalOptionBtn__1JhL-:hover .stylesForm_modalOptionIcon__NsBOY {
  color: #1a73e8;
}

.stylesForm_modalOptionTitle__W1nir {
  font-size: 15px;
  font-weight: 500;
  color: #202124;
  margin-bottom: 4px;
}

.stylesForm_modalOptionDesc__WsNke {
  font-size: 12px;
  color: #80868b;
  line-height: 1.4;
}

@media (max-width: 1200px) {
  .stylesForm_formGrid__FOLUV {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .stylesForm_formGrid__FOLUV {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ParceirosAssociados/ParceirosAssociadosForm/stylesForm.module.css"],"names":[],"mappings":"AAAA,iEAAiE;AACjE;EACE,iCAAiC;EACjC,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;IACd,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kEAAkE;EAClE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;;;EAGE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,kEAAkE;EAClE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,yBAAyB;EACzB,kBAAkB;EAClB,2DAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAO;EACP,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Ref: parceiros_formulario.html - estrutura e cores idênticas */\n.root {\n  font-family: 'Roboto', sans-serif;\n  color: #3c4043;\n  min-height: 100vh;\n  padding: 24px 0;\n}\n\n.formContainer {\n  margin: 0 2rem;\n  box-sizing: border-box;\n  background: #f5f5f5;\n  padding: 24px;\n  border-radius: 12px;\n}\n\n@media (max-width: 780px) {\n  .formContainer {\n    margin: 0 1rem;\n    padding: 16px;\n  }\n}\n\n.breadcrumb {\n  padding: 12px 24px;\n  font-size: 13px;\n  color: #80868b;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #ffffff;\n  border-bottom: 1px solid #e8eaed;\n  border-radius: 12px;\n  margin-bottom: 24px;\n}\n\n.breadcrumbLink {\n  color: #1a73e8;\n  text-decoration: none;\n}\n\n.breadcrumbLink:hover {\n  text-decoration: underline;\n}\n\n.breadcrumbSep {\n  color: #bdc1c6;\n}\n\n.mainContent {\n  padding: 2px 0 8px;\n  max-width: none;\n  box-sizing: border-box;\n}\n\n.pageTitleSection {\n  margin-bottom: 24px;\n}\n\n.pageTitle {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: #1b3a5f;\n  font-size: 26px;\n  font-weight: 600;\n  letter-spacing: -0.3px;\n  margin: 0;\n}\n\n.pageTitleIcon {\n  font-size: 32px;\n}\n\n.card {\n  background: #ffffff;\n  border-radius: 12px;\n  border: 1px solid #e0e0e0;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.06);\n  overflow: hidden;\n  margin-bottom: 24px;\n}\n\n.cardHeader {\n  padding: 16px 20px;\n  border-bottom: 1px solid #e8eaed;\n  font-size: 15px;\n  font-weight: 500;\n  color: #3c4043;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: #f8f9fa;\n}\n\n.cardHeaderIcon {\n  font-size: 22px;\n  color: #1b3a5f;\n}\n\n.cardBody {\n  padding: 20px;\n}\n\n.formGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n}\n\n.formGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.formGroupSpan2 {\n  grid-column: span 2;\n}\n\n.formGroupSpan3 {\n  grid-column: span 3;\n}\n\n.formGroupSpan4 {\n  grid-column: span 4;\n}\n\n.formGroup label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #5f6368;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.formGroup label.required::after {\n  content: ' *';\n  color: #ea4335;\n}\n\n.formGroup :global(.MuiAutocomplete-input)::selection {\n  background-color: transparent;\n  color: inherit;\n}\n\n.formGroup input:not([class*=\"Mui\"]),\n.formGroup select,\n.formGroup textarea {\n  padding: 10px 12px;\n  border: 1px solid #dadce0;\n  border-radius: 4px;\n  font-size: 14px;\n  font-family: inherit;\n  color: #3c4043;\n  background: #ffffff;\n}\n\n.formGroup input:not([class*=\"Mui\"]):focus,\n.formGroup select:focus,\n.formGroup textarea:focus {\n  outline: none;\n  border-color: #1a73e8;\n  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);\n}\n\n.formGroup input[readonly] {\n  background: #f8f9fa;\n}\n\n.formGroup textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.formHelper {\n  font-size: 12px;\n  color: #9aa0a6;\n  margin-top: 4px;\n}\n\n.sectionTitle {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1b3a5f;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 16px;\n  margin-top: 24px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.sectionTitleFirst {\n  margin-top: 0;\n}\n\n.sectionTitleIcon {\n  font-size: 18px;\n}\n\n.infoBox {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px 16px;\n  background: #e8f0fe;\n  border-radius: 6px;\n  border-left: 4px solid #1a73e8;\n  margin-bottom: 16px;\n}\n\n.infoBoxIcon {\n  color: #1a73e8;\n  font-size: 20px;\n  margin-top: 2px;\n}\n\n.infoBoxTitle {\n  font-weight: 500;\n  color: #202124;\n  margin-bottom: 4px;\n  font-size: 13px;\n}\n\n.infoBoxText {\n  font-size: 12px;\n  color: #5f6368;\n  line-height: 1.5;\n}\n\n.toggleContainer {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding-top: 22px;\n}\n\n.toggleSwitch {\n  position: relative;\n  display: inline-block;\n  width: 48px;\n  height: 24px;\n}\n\n.toggleSwitch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggleSlider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #bdc1c6;\n  transition: 0.3s;\n  border-radius: 24px;\n}\n\n.toggleSlider::before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.3s;\n  border-radius: 50%;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n}\n\n.toggleSwitch input:checked + .toggleSlider {\n  background-color: #34a853;\n}\n\n.toggleSwitch input:checked + .toggleSlider::before {\n  transform: translateX(24px);\n}\n\n.toggleLabel {\n  font-size: 14px;\n  color: #5f6368;\n  font-weight: 500;\n}\n\n.documentTypeContainer {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border: 1px solid #e8eaed;\n}\n\n.documentTypeLabel {\n  font-size: 14px;\n  font-weight: 500;\n  color: #5f6368;\n}\n\n.documentTypeLabelActive {\n  color: #1a73e8;\n}\n\n.fileUploadArea {\n  border: 2px dashed #dadce0;\n  border-radius: 6px;\n  padding: 20px;\n  text-align: center;\n  background: #f8f9fa;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.fileUploadArea:hover {\n  border-color: #1a73e8;\n  background: #e8f0fe;\n}\n\n.fileUploadIcon {\n  font-size: 48px;\n  color: #bdc1c6;\n  margin-bottom: 8px;\n  display: block;\n}\n\n.fileUploadText {\n  font-size: 14px;\n  color: #5f6368;\n  margin-bottom: 4px;\n}\n\n.fileUploadHint {\n  font-size: 12px;\n  color: #9aa0a6;\n}\n\n.tableWrapper {\n  overflow-x: auto;\n}\n\n.sociosTable {\n  width: 100%;\n  border-collapse: collapse;\n  border: 1px solid #e8eaed;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.sociosTable thead {\n  background: #1b3a5f;\n}\n\n.sociosTable th {\n  padding: 12px;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 500;\n  color: #ffffff;\n}\n\n.sociosTable td {\n  padding: 12px;\n  border-top: 1px solid #e8eaed;\n}\n\n.sociosTable tbody tr:hover {\n  background: #f8f9fa;\n}\n\n.sociosTable input {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #dadce0;\n  border-radius: 4px;\n  font-size: 13px;\n}\n\n.sociosTable input:focus {\n  outline: none;\n  border-color: #1a73e8;\n}\n\n.btnAddRow {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 12px;\n  padding: 8px 16px;\n  background: #34a853;\n  color: #ffffff;\n  border: none;\n  border-radius: 4px;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.btnAddRow:hover {\n  background: #2d9249;\n}\n\n.btnRemoveRow {\n  background: #fce8e6;\n  color: #ea4335;\n  border: none;\n  border-radius: 4px;\n  padding: 6px 10px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.btnRemoveRow:hover {\n  background: #ea4335;\n  color: #ffffff;\n}\n\n.actionFooter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  background: #ffffff;\n  border: 1px solid #e0e0e0;\n  position: sticky;\n  bottom: 0;\n  z-index: 50;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.06);\n  border-radius: 12px;\n  margin-top: 24px;\n}\n\n.footerInfo {\n  font-size: 13px;\n  color: #80868b;\n}\n\n.footerActions {\n  display: flex;\n  gap: 12px;\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  border: none;\n}\n\n.btnSuccess {\n  background: #34a853;\n  color: #ffffff;\n}\n\n.btnSuccess:hover {\n  background: #2d9249;\n}\n\n.btnOutline {\n  background: transparent;\n  border: 1px solid #dadce0;\n  color: #5f6368;\n}\n\n.btnOutline:hover {\n  background: #f8f9fa;\n  border-color: #bdc1c6;\n}\n\n.inputWithAction {\n  display: flex;\n  align-items: stretch;\n}\n\n.inputWithAction input {\n  flex: 1;\n  border-radius: 4px 0 0 4px;\n  border-right: none;\n}\n\n.btnCnpj {\n  padding: 0 12px;\n  background: #1a73e8;\n  color: #ffffff;\n  border: 1px solid #1a73e8;\n  border-radius: 0 4px 4px 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 42px;\n  transition: background 0.15s;\n  flex-shrink: 0;\n}\n\n.btnCnpj:hover:not(:disabled) {\n  background: #1557b0;\n  border-color: #1557b0;\n}\n\n.btnCnpj:disabled {\n  background: #9aa0a6;\n  border-color: #9aa0a6;\n  cursor: not-allowed;\n}\n\n.spinnerSmall {\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255,255,255,0.4);\n  border-top-color: #ffffff;\n  border-radius: 50%;\n  animation: spinSmall 0.7s linear infinite;\n  display: inline-block;\n}\n\n@keyframes spinSmall {\n  to { transform: rotate(360deg); }\n}\n\n.tooltipIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #1a73e8;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: bold;\n  margin-left: 6px;\n  cursor: help;\n}\n\n/* Modal sucesso */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0,0,0,0.5);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modalContent {\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.3);\n  max-width: 520px;\n  width: 90%;\n}\n\n.modalHeader {\n  padding: 20px 24px;\n  border-bottom: 1px solid #e8eaed;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.modalTitle {\n  font-size: 18px;\n  font-weight: 500;\n  color: #202124;\n  flex: 1;\n  margin: 0;\n}\n\n.modalSuccessIcon {\n  font-size: 28px;\n  color: #34a853;\n}\n\n.modalBody {\n  padding: 24px;\n}\n\n.modalMessage {\n  font-size: 14px;\n  color: #5f6368;\n  line-height: 1.6;\n  margin-bottom: 20px;\n}\n\n.modalHighlight {\n  font-weight: 500;\n  color: #1b3a5f;\n}\n\n.modalQuestion {\n  font-size: 15px;\n  font-weight: 500;\n  color: #202124;\n  margin-bottom: 16px;\n}\n\n.modalOptions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.modalOptionBtn {\n  display: flex;\n  align-items: center;\n  padding: 16px 20px;\n  border: 2px solid #e8eaed;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n  background: #ffffff;\n  width: 100%;\n  text-align: left;\n  font-family: inherit;\n}\n\n.modalOptionBtn:hover {\n  border-color: #1a73e8;\n  background: #e8f0fe;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n}\n\n.modalOptionBtnPrimary .modalOptionIcon {\n  color: #1a73e8;\n}\n\n.modalOptionIcon {\n  font-size: 28px;\n  margin-right: 16px;\n  color: #80868b;\n}\n\n.modalOptionBtn:hover .modalOptionIcon {\n  color: #1a73e8;\n}\n\n.modalOptionTitle {\n  font-size: 15px;\n  font-weight: 500;\n  color: #202124;\n  margin-bottom: 4px;\n}\n\n.modalOptionDesc {\n  font-size: 12px;\n  color: #80868b;\n  line-height: 1.4;\n}\n\n@media (max-width: 1200px) {\n  .formGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .formGrid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `stylesForm_root__hN1xE`,
	"formContainer": `stylesForm_formContainer__wuR+l`,
	"breadcrumb": `stylesForm_breadcrumb__cLiic`,
	"breadcrumbLink": `stylesForm_breadcrumbLink__xkKLq`,
	"breadcrumbSep": `stylesForm_breadcrumbSep__Rnq87`,
	"mainContent": `stylesForm_mainContent__gR9QC`,
	"pageTitleSection": `stylesForm_pageTitleSection__30LHC`,
	"pageTitle": `stylesForm_pageTitle__dHu3d`,
	"pageTitleIcon": `stylesForm_pageTitleIcon__8QoEl`,
	"card": `stylesForm_card__TwQkj`,
	"cardHeader": `stylesForm_cardHeader__QuRNi`,
	"cardHeaderIcon": `stylesForm_cardHeaderIcon__ztzfM`,
	"cardBody": `stylesForm_cardBody__zBzK6`,
	"formGrid": `stylesForm_formGrid__FOLUV`,
	"formGroup": `stylesForm_formGroup__obWi+`,
	"formGroupSpan2": `stylesForm_formGroupSpan2__tIs0o`,
	"formGroupSpan3": `stylesForm_formGroupSpan3__eyMG4`,
	"formGroupSpan4": `stylesForm_formGroupSpan4__S6pg4`,
	"required": `stylesForm_required__ZPTd6`,
	"formHelper": `stylesForm_formHelper__sk2Ce`,
	"sectionTitle": `stylesForm_sectionTitle__0-8Yz`,
	"sectionTitleFirst": `stylesForm_sectionTitleFirst__h5Rwt`,
	"sectionTitleIcon": `stylesForm_sectionTitleIcon__1Xx-7`,
	"infoBox": `stylesForm_infoBox__U8+Ug`,
	"infoBoxIcon": `stylesForm_infoBoxIcon__Z7eyf`,
	"infoBoxTitle": `stylesForm_infoBoxTitle__uu6tL`,
	"infoBoxText": `stylesForm_infoBoxText__kIJd+`,
	"toggleContainer": `stylesForm_toggleContainer__cKW2j`,
	"toggleSwitch": `stylesForm_toggleSwitch__bAm6z`,
	"toggleSlider": `stylesForm_toggleSlider__U2GNv`,
	"toggleLabel": `stylesForm_toggleLabel__8n-jF`,
	"documentTypeContainer": `stylesForm_documentTypeContainer__+NbjV`,
	"documentTypeLabel": `stylesForm_documentTypeLabel__SJheI`,
	"documentTypeLabelActive": `stylesForm_documentTypeLabelActive__PP4UY`,
	"fileUploadArea": `stylesForm_fileUploadArea__KqT9H`,
	"fileUploadIcon": `stylesForm_fileUploadIcon__Rgh2q`,
	"fileUploadText": `stylesForm_fileUploadText__ZOmKQ`,
	"fileUploadHint": `stylesForm_fileUploadHint__Qt6Mm`,
	"tableWrapper": `stylesForm_tableWrapper__wgl2u`,
	"sociosTable": `stylesForm_sociosTable__TWxaN`,
	"btnAddRow": `stylesForm_btnAddRow__15rHq`,
	"btnRemoveRow": `stylesForm_btnRemoveRow__nrSny`,
	"actionFooter": `stylesForm_actionFooter__R29LH`,
	"footerInfo": `stylesForm_footerInfo__MKgUi`,
	"footerActions": `stylesForm_footerActions__BwzHJ`,
	"btn": `stylesForm_btn__+YD8C`,
	"btnSuccess": `stylesForm_btnSuccess__bQP5b`,
	"btnOutline": `stylesForm_btnOutline__7nQil`,
	"inputWithAction": `stylesForm_inputWithAction__ZIAfM`,
	"btnCnpj": `stylesForm_btnCnpj__5LVxW`,
	"spinnerSmall": `stylesForm_spinnerSmall__YOAWc`,
	"spinSmall": `stylesForm_spinSmall__wjIGi`,
	"tooltipIcon": `stylesForm_tooltipIcon__mvPRH`,
	"modalOverlay": `stylesForm_modalOverlay__4Mmkv`,
	"modalContent": `stylesForm_modalContent__cWzF7`,
	"modalHeader": `stylesForm_modalHeader__R4KmN`,
	"modalTitle": `stylesForm_modalTitle__nhrBL`,
	"modalSuccessIcon": `stylesForm_modalSuccessIcon__OV9OM`,
	"modalBody": `stylesForm_modalBody__JUr+M`,
	"modalMessage": `stylesForm_modalMessage__pUZou`,
	"modalHighlight": `stylesForm_modalHighlight__KykKF`,
	"modalQuestion": `stylesForm_modalQuestion__AAPj2`,
	"modalOptions": `stylesForm_modalOptions__AwKKk`,
	"modalOptionBtn": `stylesForm_modalOptionBtn__1JhL-`,
	"modalOptionBtnPrimary": `stylesForm_modalOptionBtnPrimary__pnc8+`,
	"modalOptionIcon": `stylesForm_modalOptionIcon__NsBOY`,
	"modalOptionTitle": `stylesForm_modalOptionTitle__W1nir`,
	"modalOptionDesc": `stylesForm_modalOptionDesc__WsNke`
};
export default ___CSS_LOADER_EXPORT___;
